<template>
  <div class="crop-card" :class="{'is-selected': selected,'out-of-stock': outOfStock}">
    <div class="crop-image" @click="handleSelected">
      <img :src="seedImage" width="96" height="96">
    </div>
    <div class="crop-content" @click="handleSelected">
      <h3 class="heading-crop" v-text="name"></h3>
      <dl class="crop-summary">
        <dt class="sr-only">Cost Rating</dt>
        <dd>
          <span class="cost-rating" :class="seedCostCategory">
            <span class="sr-only" v-text="seedCost"></span>
          </span>
        </dd>
        <dt>Full Seeding Rate</dt>
        <dd v-html="seedingRate"></dd>
      </dl>
    </div>
    <div class="crop-buttons">
      <span v-show="outOfStock" class="btn btn-primary" disabled><span class="text">Out of Stock</span></span>
      <button v-show="!selected && !outOfStock" class="btn btn-primary btn-add" @click="handleSelected"><span class="text">Add To Mix</span></button>
      <span v-show="selected" class="amount" @click="handleSelected">{{ amount }} <small>lbs/acre</small></span>
      <button v-show="selected" class="btn btn-remove" @click="$emit('removed', crop)"><span class="sr-only">Remove</span></button>
    </div>
  </div>
</template>

<script>
import Images from '../data/seed-images.json'
export default {
  props: ['crop'],
  data () {
    return {
      seedimages: Images
    }
  },
  methods: {
    handleSelected () {
      if (this.outOfStock) {
        return
      }
      this.$emit('selected', this.crop)
    }
  },
  computed: {
    name () {
      return this.crop['species']
    },
    seedingRate () {
      return this.crop['seedingRate'] + ' <small>lbs/acre</small>'
    },
    seedCost () {
      return this.crop['pricePerLb'].replace(/\s/g, '') + '/lb'
    },
    seedCostCategory () {
      return this.crop['pricePerAcreCategory'].replace(/\s/g, '-').toLowerCase()
    },
    seedImage () {
      let img = this.seedimages[0][this.crop['id']]
      return img ? '/assets/seeds/thumbs/' + img + '.jpg' : '/assets/seed-placeholder-thumb.jpg'
    },
    selected () {
      let foundMatch = false
      this.$store.state.formData.selectedCrops.forEach((entry, index) => {
        if (this.crop['species'] === entry.crop['species']) {
          foundMatch = true
        }
      })
      return foundMatch
    },
    amount () {
      let amount = 0
      this.$store.state.formData.selectedCrops.forEach((entry, index) => {
        if (this.crop['species'] === entry.crop['species']) {
          amount = entry.amount
        }
      })
      return amount
    },
    outOfStock () {
      return this.crop['inStock'] === '0'
    }
  }
}
</script>

<style lang="scss">
  .crop-card {
    position: relative;
    transition: all 0.2s ease-in-out;
    color: $color-black;
    padding: 20px;
    border-bottom: solid 1px #D8DCCC;
    @include media-breakpoint-up(md){
      padding: 0;
      display: flex;
    }
    &.is-selected {
      background: #E7EBD9;
      .crop-buttons{
        opacity: 1;
        justify-content: space-between;
        @include media-breakpoint-up(md){
          justify-content: flex-end;
          transform: scale(1.0);
        }
        .btn{
          margin-left: 23px;
        }
      }
    }
    &.out-of-stock{
      pointer-events: none;
      .crop-buttons{
        opacity: 1;
      }
    }
    @include media-breakpoint-up(lg){
      &:hover {
        .crop-buttons {
          opacity: 1;
          transform: scale(1.0);
        }
        .amount{
          opacity: 1;
          background-image: url('/assets/pencil.svg');
        }
      }
    }
    .crop-image{
      @include media-breakpoint-down(sm){
        display: none;
      }
    }
    .btn[disabled]{
      opacity: .75;
      padding-inline: 19px;
      border: none;
      background: none;
    }
  }
  .crop-image {
    width: 96px;
    cursor: pointer;
    img {
      display: block;
      border-radius: 3px 0 0 3px;
    }
  }
  .crop-content {
    text-align: left;
    cursor: pointer;
    @include media-breakpoint-up(md){
      padding: 0 22px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 1;
    }
  }
  .heading-crop {
    color: $color-black;
    font-size: 20px;
    line-height: 1.2;
    font-weight: 600;
    padding-right: 40px;
    margin: 0 0 .5em;
    text-transform: capitalize;
  }
  .crop-summary {
    display: flex;
    align-items: center;
    color: $color-black;
    font-weight: 600;
    margin: 0;
    opacity: .7;
    dt, dd{
      margin: 0 10px 0 0;
      font-weight: 600;
      text-transform: uppercase;
      @include media-breakpoint-up(md){
        margin: 0 15px 0 0;
      }
    }
    dt{
      font-size: 12px;
      letter-spacing: 1px;
      @include media-breakpoint-up(md){
        font-size: 14px;
      }
    }
    dd{
      font-size: 14px;
      @include media-breakpoint-up(md){
        font-size: 16px;
      }
    }
    small{
      font-size: 12px;
      text-transform: none;
      @include media-breakpoint-up(md){
        font-size: 14px;
      }
    }
  }
  .cost-rating{
    font-size: 13px;
    line-height: 24px;
    color: $color-white;
    background: $color-dark-green;
    border-radius: 24px;
    padding: 0 6px 0 8px;
    letter-spacing: 3px;
    display: inline-block;
    font-weight: 600;
    &.very-low{
      &::before{
        content: '$'
      }
    }
    &.low{
      &::before{
        content: '$$'
      }
    }
    &.medium{
      &::before{
        content: '$$$'
      }
    }
    &.high{
      &::before{
        content: '$$$$'
      }
    }
  }
  .crop-buttons {
    display: flex;
    align-items: center;
    @include media-breakpoint-up(md){
      margin-right: 15px;
      justify-content: space-between;
    }
    @include media-breakpoint-up(lg){
      margin-right: 30px;
      transform: scale(1.05);
      opacity: 0;
      transition: all 0.2s ease-in-out;
    }
    .btn {
      width: auto;
      border: 1px solid rgba(44, 106, 46, 0.15);
      margin: 0;
      @include media-breakpoint-up(lg){
        height: 60px;
        &:hover {
          box-shadow: 0 0 0 rgba($color-black, 0.0);
          border: 1px solid rgba(44, 106, 46, 0.45);
        }
      }
    }
    .btn-clear {
      color: $color-black;
    }
    .btn-add{
      @include media-breakpoint-down(sm){
        position: absolute;
        right: 15px;
        top: 15px;
        background-color: transparent;
        background-position: center center;
        border: 0;
        padding: 0;
        width: 30px;
        height: 30px;
        .text{
          @include sr-only;
        }
      }
    }
    .btn-remove{
      width: 30px;
      height: 30px;
      border-radius: 3px;
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
      opacity: 0.95;
      padding: 0;
      background: $color-white url('/assets/close-green.svg') no-repeat center 8px;
      background-size: 14px auto;
      border-color: $color-white;
      position: absolute;
      right: 15px;
      top: 15px;
      @include media-breakpoint-up(md){
        position: static;
        &:hover{
          border-color: $color-white;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
          background-color: $color-white;
          background-image: url('/assets/close-black.svg');
        }
      }
    }
    .amount{
      cursor: pointer;
      font-weight: 600;
      background: none;
      border: 0;
      opacity: .6;
      transition: .2s;
      padding: 0 0 0 25px;
      background: url('/assets/pencil.svg') no-repeat left 2px;
      margin-top: 15px;
      @include media-breakpoint-up(lg){
        margin: 0;
        padding: 0 0 0 25px;
        background: no-repeat left 2px;
      }
      small{
        font-style: 14px;
      }
    }
  }
</style>
